import React from 'react';
import { useNavigate } from 'react-router-dom';
import previousWork from '../data/previousWork';
import { INSTAGRAM_URL } from '../config/constants';

export default function PreviousWork() {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: "'Archivo', sans-serif", background: '#FAFAF7', minHeight: '100vh' }}>

      <nav className="site-nav" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: 'rgba(244, 239, 226, 0.94)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <img src="/logo-banner.svg" alt="Garden & Groundworks" className="header-logo"
            style={{ width: 'auto', display: 'block' }} />
        </div>
        <button onClick={() => navigate('/quote')} className="nav-quote-btn"
          style={{ background: '#C8A84B', color: 'white', border: 'none', borderRadius: 8,
            padding: '10px 20px', fontFamily: 'inherit', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer' }}>
          Get a quote
        </button>
      </nav>

      <div style={{ padding: 'clamp(140px, 20vw, 170px) clamp(16px, 5vw, 64px) clamp(24px, 8vw, 48px)' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>

          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <h1 style={{ fontSize: 'clamp(1.8rem, 5vw, 2.6rem)', color: '#1B4F2A', fontWeight: 400, marginBottom: 12 }}>
              Previous work
            </h1>
            <p style={{ color: '#666', fontSize: '1.05rem', maxWidth: 560, margin: '0 auto', lineHeight: 1.6 }}>
              A few highlights from recent jobs around Guernsey.
            </p>
          </div>

          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              background: 'linear-gradient(135deg, #C8A84B 0%, #a8882e 100%)', color: 'white',
              textDecoration: 'none', borderRadius: 12, padding: '16px 24px', marginBottom: 40,
              fontWeight: 700, fontSize: '1rem', boxShadow: '0 4px 20px rgba(200,168,75,0.35)' }}>
            📸 Follow us on Instagram for regular updates →
          </a>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24, marginBottom: 48 }}>
            {previousWork.map(entry => (
              <div key={entry.title} style={{ background: 'white', borderRadius: 16,
                overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
                border: '1px solid #EEE', display: 'flex', flexDirection: 'column' }}>
                {entry.images?.length > 0 && (
                  <div style={{ display: 'flex', gap: 3, height: 220, flexShrink: 0 }}>
                    {entry.images.map(src => (
                      <img key={src} src={src} alt={entry.title} loading="lazy"
                        style={{ flex: 1, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
                    ))}
                  </div>
                )}
                <div style={{ padding: '20px', flex: 1 }}>
                  <h3 className="font-heading" style={{ color: '#1B4F2A', fontSize: '1.1rem', fontWeight: 700, marginBottom: 8 }}>
                    {entry.title}
                  </h3>
                  <p style={{ color: '#666', fontSize: '1rem', lineHeight: 1.6, margin: 0 }}>{entry.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ background: 'white', borderRadius: 16, padding: 'clamp(24px, 5vw, 36px)',
            border: '1px solid #EEE', boxShadow: '0 2px 16px rgba(0,0,0,0.07)', maxWidth: 760, margin: '0 auto' }}>
            <h2 className="font-heading" style={{ color: '#1B4F2A', fontSize: '1.3rem', fontWeight: 700, marginBottom: 14 }}>
              Biosecurity — clean between every site
            </h2>
            <div style={{ color: '#555', fontSize: '0.98rem', lineHeight: 1.75 }}>
              <p>
                Soil movement is one of the main ways tree and plant diseases spread between gardens.
                Contaminated soil and root material carried on a digger bucket, tracks, a trailer or boots
                can move pathogens like honey fungus (Armillaria) and Phytophthora from an infected site to
                a healthy one. So I clean soil, roots and debris off machinery, tools and boots before
                leaving every job — the practice the Forestry Commission promotes through its
                "Keep it Clean" campaign.
              </p>
              <p>
                For routine work that means thorough cleaning and drying. Where I've knowingly handled
                diseased material — a honey-fungus stump, an infected tree — I disinfect tools and
                equipment before the next site rather than relying on cleaning alone. Infected roots and
                stumps are disposed of properly, never composted, because that's how these diseases travel.
              </p>
              <p>
                As a doctor, the logic is familiar: I treat it like infection control. Clean as a matter
                of course, sterilise when the situation calls for it. The point isn't to strip life from
                the soil — quite the opposite. Healthy compost and living soil are exactly what
                regenerative gardening protects and builds. It's the harmful transmission I'm stopping at
                the gate, not the beneficial biology.
              </p>
            </div>
          </div>

        </div>
      </div>

      <div style={{ background: '#111', padding: '32px 24px', textAlign: 'center', marginTop: 48 }}>
        <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem', lineHeight: 1.8 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
            <img src="/logo-lockup-reversed.svg" alt="Garden & Groundworks"
              style={{ height: 39.2, width: 'auto', display: 'block' }} />
          </div>
          Le Val Farm, Route Des Blicqs, St Andrews, Guernsey GY6 8YD<br />
          Insured with Zurich Insurance — Public Liability £2,000,000<br />
          <span style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.4)', fontSize: '0.75rem' }}
            onClick={() => navigate('/')}>Back to home</span>
        </div>
      </div>

    </div>
  );
}
